import {NullAsDefault} from "views/Shared";
import React from 'react'

const ServerContext = React.createContext(
  {
    onFollow: NullAsDefault,
    item: {},
    routes: [],
    current: '',
    setCurrent: NullAsDefault
  }
)
export default ServerContext
